import { DateTime } from 'luxon';
import { computed, Ref } from 'vue';
import { calculateConflictsByDay } from '../logic/conflicts';
import { Allocation, ConflictsByDay } from '../Timeline.types';

export function useTimelineConflicts(
    allocations: Ref<Allocation[]>,
    startDateTime: Ref<DateTime | undefined>,
    endDateTime: Ref<DateTime | undefined>,
): { conflictsByDay: Ref<ConflictsByDay> } {
    const conflictsByDay = computed<ConflictsByDay>(() => {
        if (startDateTime.value === undefined || endDateTime.value === undefined) {
            return new Map();
        }

        const durationInDays = endDateTime.value.diff(startDateTime.value, 'days').days;

        return calculateConflictsByDay(allocations.value, startDateTime.value, durationInDays);
    });

    return { conflictsByDay };
}
